module.exports = __webpack_public_path__ + "media/application/images/svgs/globe-75e4b872b5a6368b044725ba911d5cdc.svg";